import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" generate random direct transfer ");
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { TransferListing } from "@/modules/transfer-market/entity";
import ListingTable from "@/modules/transfer-market/components/ListingTable.vue";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import RichDialogRow from "@/modules/vue/components/RichDialogRow.vue";
import { app } from "@/di";
import OfferCreator from "@/modules/transfer-market/services/OfferCreator";
import { Team } from "@/modules/team/entity";
import NavBarMenu from "@/modules/transfer-market/pages/NavBarMenu.vue";
import PlayerQueryPaginator from "@/modules/global-search/components/PlayerQueryPaginator.vue";
import SimpleActionSheet from "@/modules/vue/components/SimpleActionSheet.vue";
import SimpleActionSheetItem from "@/modules/vue/components/SimpleActionSheetItem.vue";
import DirectTransferHandler from "@/modules/transfer-market/services/DirectTransferHandler";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {
    const query = ref(TransferListing.createQueryBuilder('listing').innerJoinAndSelect('listing.player', 'player').innerJoinAndSelect('player.country', 'country').leftJoinAndSelect('player.team', 'playerTeam').leftJoinAndSelect('listing.offers', 'offer').leftJoin('offer.team', 'team', 'team.user = true'));
    const router = useRouter();
    const selectedListing = ref();
    const offerConfirmation = ref(null);
    const onClickCreateOffer = listing => {
      selectedListing.value = listing;
      nextTick(() => {
        offerConfirmation.value.confirm().then(async () => {
          await selectedListing.value.player.load('team');
          const offer = await app.get(OfferCreator).create(selectedListing.value.player, await Team.current(), selectedListing.value.price, selectedListing.value);
          await router.push({
            name: 'transfer-market.team-offers.show',
            params: {
              id: offer.id
            }
          });
        });
      });
    };
    const generateRandomDirectTransfer = async () => {
      const player = await app.get(DirectTransferHandler).handle(await Team.current());
      if (!player) {
        return;
      }
      router.push({
        name: 'players.show',
        params: {
          id: player.id
        }
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: "",
        "no-content-padding": ""
      }, _createSlots({
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('transfer_market')), 1)]),
        submenu: _withCtx(({
          route
        }) => [_createVNode(NavBarMenu)]),
        default: _withCtx(() => [_createVNode(PlayerQueryPaginator, {
          query: query.value
        }, {
          default: _withCtx(({
            items
          }) => [_createVNode(ListingTable, {
            listings: items,
            class: "w-full",
            onClickCreateOffer: onClickCreateOffer
          }, null, 8, ["listings"]), selectedListing.value ? (_openBlock(), _createBlock(RichDialog, {
            key: 0,
            ref_key: "offerConfirmation",
            ref: offerConfirmation
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('start_negotiations')), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              innerHTML: _ctx.$t('do_you_want_to_start_negotiations_for_player', {
                player: selectedListing.value.player.shortName
              })
            }, null, 8, _hoisted_1), _createVNode(RichDialogRow, null, {
              label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('base_price')), 1)]),
              value: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$money(selectedListing.value.price)), 1)]),
              _: 1
            })]),
            _: 1
          }, 512)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["query"])]),
        _: 2
      }, [_ctx.$debug ? {
        name: "actionButton",
        fn: _withCtx(() => [_createVNode(SimpleActionSheet, {
          ref: "simpleActionSheet",
          "no-teleport": ""
        }, {
          actions: _withCtx(() => [_createVNode(SimpleActionSheetItem, {
            class: "italic",
            onClick: generateRandomDirectTransfer
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        }, 512)])
      } : undefined]), 1024);
    };
  }
});